import { useEffect, useState } from 'react';
import { isOverwolfAvailable } from '../services/overwolf/overwolf-api.service';

// -----------------------------------------------------------------------------
// Detects whether the page runs inside the Overwolf app shell: embedded in an
// iframe (window.self !== window.top) AND the client has injected the `overwolf`
// global. The check can only run after mount, so `isResolved` is false during
// SSR / first render and flips to true once the (post-mount) check has run.
// Gate any rendered markup on `isResolved` so web-only / iframe-only UI doesn't
// flash before we actually know which context we're in.
interface OverwolfIframeState {
  isOverwolfIframe: boolean;
  isResolved: boolean;
}

const useIsOverwolfIframe = (): OverwolfIframeState => {
  const [state, setState] = useState<OverwolfIframeState>({
    isOverwolfIframe: false,
    isResolved: false,
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    setState({
      isOverwolfIframe: window.self !== window.top && isOverwolfAvailable(),
      isResolved: true,
    });
  }, []);

  return state;
};

export default useIsOverwolfIframe;
